module.exports = __webpack_public_path__ + "media/v2/components/Contests/shared/Image/shape-217d12323999de52c153f58ea2666a64.svg";